// extracted by mini-css-extract-plugin
export default {"slideshow":"slideshow-crossfade_slideshow__2ZUnY","slide":"slideshow-crossfade_slide__Lyoud","active":"slideshow-crossfade_active__O6pvx"};